import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    heading: "1. Acceptation",
    paragraphs: [
      "En telechargeant, accedant ou utilisant GoalFit, vous acceptez ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, n'utilisez pas le service."
    ],
  },
  {
    heading: "2. Le service GoalFit",
    paragraphs: [
      "GoalFit fournit des outils numeriques pour creer des objectifs fitness hebdomadaires, suivre des entrainements, consulter votre progression, recevoir des notifications, entrer en relation avec des coachs et acceder a certaines fonctionnalites premium."
    ],
  },
  {
    heading: "3. Compte utilisateur",
    paragraphs: [
      "Vous etes responsable des informations fournies lors de l'inscription et de la confidentialite de vos identifiants.",
      "Vous acceptez de fournir des informations exactes et de ne pas partager votre compte avec une autre personne."
    ],
    bullets: [
      "L'inscription GoalFit repose notamment sur votre nom, votre numero de telephone, votre mot de passe et votre role utilisateur.",
      "Vous etes responsable de toute activite effectuee depuis votre compte.",
      "Nous pouvons suspendre ou limiter l'acces en cas d'utilisation abusive, frauduleuse ou contraire a ces conditions."
    ],
  },
  {
    heading: "4. Abonnements, achats et acces premium",
    paragraphs: [
      "Certaines fonctionnalites peuvent etre gratuites, tandis que d'autres peuvent necessiter un abonnement ou un achat integre, notamment pour debloquer des objectifs supplementaires ou des offres premium.",
      "Les achats integres sont traites par la boutique de votre plateforme et peuvent s'appuyer sur des services tiers comme RevenueCat pour la gestion d'acces."
    ],
    bullets: [
      "Les prix, periodes d'essai et conditions de renouvellement sont affiches dans l'application au moment de l'achat.",
      "La facturation, l'annulation et le remboursement suivent principalement les regles de l'App Store ou de Google Play, selon la plateforme utilisee.",
      "La restauration d'achat depend de votre compte de boutique et de l'etat du service associe."
    ],
  },
  {
    heading: "5. Coachs et communications",
    paragraphs: [
      "GoalFit peut proposer des fonctionnalites permettant d'identifier, contacter ou echanger avec des coachs. Vous restez responsable du contenu que vous envoyez et des decisions que vous prenez sur la base de ces echanges."
    ],
  },
  {
    heading: "6. Sante et responsabilite personnelle",
    paragraphs: [
      "GoalFit fournit du contenu de fitness, de motivation et d'organisation. Le service ne constitue pas un avis medical, un diagnostic ni un traitement.",
      "Avant de commencer un programme sportif, surtout si vous avez une condition medicale, vous devez obtenir l'avis d'un professionnel de sante qualifie. Vous utilisez GoalFit a vos propres risques."
    ],
  },
  {
    heading: "7. Utilisation interdite",
    paragraphs: [
      "Vous acceptez de ne pas utiliser GoalFit d'une maniere illegale, nuisible ou susceptible de perturber le service."
    ],
    bullets: [
      "Usurper l'identite d'une autre personne ou fournir de fausses informations.",
      "Tenter d'acceder sans autorisation aux serveurs, comptes ou donnees d'autrui.",
      "Publier ou transmettre du contenu injurieux, harcelant, frauduleux ou illicite.",
      "Contourner les restrictions techniques, commerciales ou de securite du service."
    ],
  },
  {
    heading: "8. Propriete intellectuelle",
    paragraphs: [
      "L'application GoalFit, son design, sa marque, son contenu, ses elements visuels et ses fonctionnalites restent proteges par les lois applicables en matiere de propriete intellectuelle. Sauf autorisation ecrite, vous ne pouvez pas copier, redistribuer ou exploiter commercialement ces elements."
    ],
  },
  {
    heading: "9. Disponibilite et evolution",
    paragraphs: [
      "Nous pouvons modifier, suspendre ou retirer certaines fonctionnalites de GoalFit a tout moment, y compris l'acces a des coachs, a des integrations tierces, a des notifications ou a des offres d'abonnement."
    ],
  },
  {
    heading: "10. Limitation de responsabilite",
    paragraphs: [
      "Dans la mesure permise par la loi applicable, GoalFit est fourni tel quel, sans garantie de disponibilite ininterrompue, d'absence d'erreur ou d'adequation a un objectif particulier. Nous ne serons pas responsables des dommages indirects, consecutifs ou lies a une utilisation inappropriee du service."
    ],
  },
  {
    heading: "11. Resiliation",
    paragraphs: [
      "Vous pouvez cesser d'utiliser GoalFit a tout moment. Nous pouvons egalement suspendre ou resilier votre acces si vous ne respectez pas ces conditions ou si cela est necessaire pour proteger le service, les utilisateurs ou nos droits."
    ],
  },
  {
    heading: "12. Modifications des conditions",
    paragraphs: [
      "Nous pouvons mettre a jour ces conditions d'utilisation. La version publiee sur ce site indique la date de derniere mise a jour et s'applique a compter de sa publication, sauf mention contraire."
    ],
  },
  {
    heading: "13. Contact",
    paragraphs: [
      "Pour toute question relative a ces conditions, vous pouvez nous ecrire a goalfit.support@loven-soft.com."
    ],
  },
];

export default function TermsPage() {
  return (
    <LegalPage
      title="Conditions d'utilisation"
      updatedAt="27 avril 2026"
      intro="Ces conditions regissent l'utilisation de l'application mobile GoalFit, de ses pages publiques et des services associes."
      sections={sections}
    />
  );
}
